import script from "./AddRoomsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRoomsSection.vue?vue&type=script&setup=true&lang=js"

import "./AddRoomsSection.vue?vue&type=style&index=0&id=34573f0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34573f0f"]])

export default __exports__